import { CommentFragment, getTypeOrNull } from '@spotify/confidence-graphql';
import { useCurrentUser } from '@spotify/plugin-confidence-iam-react';

export const useAssignCount = (
  comments: Array<Pick<CommentFragment, 'resolved' | 'assignee'>>,
) => {
  // Get the number of assigned threads that the current user has.
  const { currentUser } = useCurrentUser();

  const assignCount =
    comments
      ?.filter(c => !c.resolved)
      ?.filter(
        c => getTypeOrNull(c.assignee)?.name === currentUser?.identity?.name,
      )?.length ?? 0;

  return assignCount;
};
